"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import EmmaListSearchItems from "./EmmaListSearchItems";
import { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import { useClickAway, useKeyPressEvent } from "react-use";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
export default function EmmaListSearch(t0) {
  const $ = _c(25);
  const {
    selectedId,
    onSelect
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = newV => {
      if (newV) {
        setIsOpen(true);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onFocusChange = t1;
  const [searchCriteria, setSearchCriteria] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = newV_0 => {
      setSearchCriteria(newV_0);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onSearchCriteriaChange = t2;
  const wrapperRef = useRef(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useClickAway(wrapperRef, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useKeyPressEvent("Escape", t4);
  let t5;
  if ($[4] !== onSelect) {
    t5 = item => {
      onSelect(item);
      setSearchCriteria(item.name);
      setIsOpen(false);
    };
    $[4] = onSelect;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const onItemSelect = t5;
  let t6;
  let t7;
  if ($[6] !== selectedId) {
    t6 = () => {
      if (!selectedId) {
        setSearchCriteria(null);
      }
    };
    t7 = [selectedId];
    $[6] = selectedId;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  useEffect(t6, t7);
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getRandomObjectId();
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const randomId = t8;
  const t9 = searchCriteria ?? "";
  let t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e => onSearchCriteriaChange(e.target.value);
    t11 = () => onFocusChange(true);
    t12 = () => onFocusChange(false);
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t9) {
    t13 = <input type="text" value={t9} onChange={t10} onFocus={t11} onBlur={t12} id={randomId} className={"tw-form-input tw-block tw-pb-3 tw-pt-3 tw-pl-10 tw-pr-4 tw-w-full tw-text-md tw-rounded-lg tw-border-0 tw-appearance-none tw-text-white tw-border-iron-700 focus:tw-border-blue-500 tw-peer\n     tw-bg-iron-900  focus:tw-bg-iron-900 tw-font-medium tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-650 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"} placeholder=" " />;
    $[13] = t9;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <svg className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    t15 = <label htmlFor={randomId} className={"tw-absolute tw-rounded-lg tw-cursor-text tw-text-md tw-font-medium tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-ml-7 tw-px-2 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 peer-placeholder-shown:tw-scale-100 \n                        peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>Search allowlist</label>;
    $[15] = t14;
    $[16] = t15;
  } else {
    t14 = $[15];
    t15 = $[16];
  }
  let t16;
  if ($[17] !== isOpen || $[18] !== onItemSelect || $[19] !== searchCriteria || $[20] !== selectedId) {
    t16 = <EmmaListSearchItems open={isOpen} searchCriteria={searchCriteria} selectedId={selectedId} onSelect={onItemSelect} />;
    $[17] = isOpen;
    $[18] = onItemSelect;
    $[19] = searchCriteria;
    $[20] = selectedId;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t13 || $[23] !== t16) {
    t17 = <div className="tw-group tw-w-full tw-relative" ref={wrapperRef}>{t13}{t14}{t15}{t16}</div>;
    $[22] = t13;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  return t17;
}